//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'InstructorInfo',
  props: {
    instructor: {
      type: Object,
      default: () => ({}),
    },
    directory: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    truncatedBio () {
      if (this.directory && this.instructor.bio && this.instructor.bio.length > 150) {
        return this.instructor.bio.substring(0, 500) + '...';
      }
      return this.instructor.bio;
    },
    hasSocialLinks () {
      const { socialLinksMap } = this.instructor;
      return (
        socialLinksMap.x ||
        socialLinksMap.facebook ||
        socialLinksMap.linkedin ||
        socialLinksMap.instagram ||
        socialLinksMap.tiktok ||
        socialLinksMap.website ||
        socialLinksMap.youtube
      );
    },
  },
};
